import { render } from "./PanelsGroup.vue?vue&type=template&id=d825a908&scoped=true"
import script from "./PanelsGroup.vue?vue&type=script&lang=js"
export * from "./PanelsGroup.vue?vue&type=script&lang=js"

import "./PanelsGroup.vue?vue&type=style&index=0&id=d825a908&scoped=true&lang=scss"
import "./PanelsGroup.vue?vue&type=style&index=1&id=d825a908&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d825a908"]])

export default __exports__